

import { Typography } from "../../UI/Typography";
import { Modal } from "../Modal";
import { Box } from "../../UI/Box";
import { Button } from "../../UI/Button";
import { QuestionsHelp } from "../QuestionsHelp";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Link } from "../Link";
import { URL } from "../../constants/navigation";
import { useHistory } from "react-router";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { useNetwork } from "../../hooks/useNetwork";

const DescModal = () => {
  const { setIsOpen } = useModalContext();

  const onHide = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      title="Placement Worksheet"
      actions={
        <Button appearance="subtle" onClick={onHide}>
          Cancel
        </Button>
      }
    >
      <Box px={3} py={2}>
        <Typography variant="body2" gutterBottom>
          This tool is designed to be an internal working draft and does not create official assignments in your
          property management system.
        </Typography>
        <Typography variant="body2" gutterBottom>
          If you create a match during a placement with this tool, residents will be able to see that match in their
          RoomSync account, however, they will not be able to see what unit or room you’ve placed them in on this
          worksheet.
        </Typography>
        <Typography variant="body2" gutterBottom>
          All notes on this worksheet are for internal use only and cannot be seen by residents.
        </Typography>
        <QuestionsHelp />
      </Box>
    </Modal>
  );
};

export const PlacementWorksheetDesc = () => {
  const { setIsOpen } = useModalContext();
  const { push } = useHistory();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { getL3 } = useNetwork();
  const { l3Id, l2Id } = usePlacementWorksheetContext();

  const onClick = () => {
    setIsOpen(true);
  };

  const navToMatchGroup = () => push(URL.MATCH_RULES);

  const l3 = selectedNetworkId && l2Id && l3Id ? getL3(selectedNetworkId, l2Id, l3Id) : undefined;

  const maxMatchText = l3 ? (
    <>
      {l3.maxNumberOfMatches} units are displayed below for placements. Update your{" "}
      <Link onClick={navToMatchGroup}>Maximum Match Group</Link> setting to update the number of rows that are
      displayed.
    </>
  ) : (
    ""
  );

  return (
    <>
      <Typography variant="body2">
        Use this tool to draft unit and room placements and see available rooms based on the placements you choose. To
        the right are match groups of two or more roommates you can begin placing as well as residents who have not yet
        chosen a match. {maxMatchText} <Link onClick={onClick}>Learn more</Link>
      </Typography>

      <Typography
        variant="body2"
        mt={2}
        mb={3}
        sx={{ fontWeight: "600 !important" }}
      >
        Residents cannot see what unit or bedroom you've selected for them using this tool.
      </Typography>
      <DescModal />
    </>
  );
};
